import { slicedToArray as _slicedToArray, defineProperty as _defineProperty, typeof as _typeof } from '../_virtual/_rollupPluginBabelHelpers.js';

var functionalHelpers = function functionalHelpers(props, defaultProps) {
  return defaultProps ? Object.assign(Object.assign({}, defaultProps), Object.entries(props).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];
    return v === undefined ? acc : Object.assign(Object.assign({}, acc), _defineProperty({}, k, v));
  }, {})) : props;
};
// Helper to use a ref both externally and internally
// improved version of this: https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd
// TODO typing
var reuseRef = function reuseRef(getExternalRef) {
  var element;
  var getElement = function getElement() {
    var _a;
    return ((_a = getExternalRef()) === null || _a === void 0 ? void 0 : _a.current) || element;
  };
  var getRef = function getRef() {
    var externalRef = getExternalRef();
    switch (_typeof(externalRef)) {
      case "function":
        return function (r) {
          externalRef(r);
          element = r;
        };
      case "object":
        return externalRef;
      default:
        return function (r) {
          return element = r;
        };
    }
  };
  return [getRef, getElement];
};

export { functionalHelpers, reuseRef };
